import { FunctionComponent, SVGProps } from 'react';
import { IconName } from './types';
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow-down.svg';
import { ReactComponent as Checkmark } from '../../../assets/icons/checkmark.svg';
import { ReactComponent as Continue } from '../../../assets/icons/continue.svg';
import { ReactComponent as DFINLogo } from '../../../assets/icons/dfin-logo.svg';
import { ReactComponent as EdgarNextLogo } from '../../../assets/icons/edgar-next-logo.svg';
import { ReactComponent as Error } from '../../../assets/icons/error.svg';
import { ReactComponent as Exit } from '../../../assets/icons/exit.svg';
import { ReactComponent as Help } from '../../../assets/icons/help.svg';
import { ReactComponent as Info } from '../../../assets/icons/info.svg';
import { ReactComponent as NavArrow } from '../../../assets/icons/nav-arrow.svg';
import { ReactComponent as Success } from '../../../assets/icons/success.svg';
import { ReactComponent as User } from '../../../assets/icons/user.svg';
import { ReactComponent as Users } from '../../../assets/icons/users.svg';

export type IconComponent = FunctionComponent<SVGProps<SVGSVGElement>>;

export const IconsMap = new Map<IconName, IconComponent>([
  [IconName.ArrowDown, ArrowDown],
  [IconName.Checkmark, Checkmark],
  [IconName.Continue, Continue],
  [IconName.DFINLogo, DFINLogo],
  [IconName.EdgarNextLogo, EdgarNextLogo],
  [IconName.Error, Error],
  [IconName.Exit, Exit],
  [IconName.Help, Help],
  [IconName.Info, Info],
  [IconName.NavArrow, NavArrow],
  [IconName.Success, Success],
  [IconName.User, User],
  [IconName.Users, Users],
]);
